var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("backHead"),
      _c(
        "div",
        { staticClass: "loginbox" },
        [
          _c("div", { staticClass: "headetitle" }, [_vm._v("注册")]),
          _c(
            "el-form",
            {
              ref: "RegisterForm",
              staticClass: "demo-ruleForm",
              attrs: {
                autoComplete: "on",
                model: _vm.RegisterForm,
                rules: _vm.loginRules
              }
            },
            [
              _c(
                "el-form-item",
                { staticClass: "inputstyle", attrs: { prop: "phone" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "tel",
                      placeholder: "请输入手机号码",
                      maxlength: "11"
                    },
                    model: {
                      value: _vm.RegisterForm.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.RegisterForm, "phone", $$v)
                      },
                      expression: "RegisterForm.phone"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "inputstyle rel", attrs: { prop: "captcha" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "tel",
                      placeholder: "请输入验证码",
                      maxlength: "6"
                    },
                    model: {
                      value: _vm.RegisterForm.captcha,
                      callback: function($$v) {
                        _vm.$set(_vm.RegisterForm, "captcha", $$v)
                      },
                      expression: "RegisterForm.captcha"
                    }
                  }),
                  _c(
                    "b",
                    {
                      staticClass: "getCode",
                      on: {
                        click: function($event) {
                          return _vm.getCode("RegisterForm")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.phonetime.time))]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "inputstyle  onlybox",
                  attrs: { prop: "password" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "password",
                      placeholder: "请输入6-20位密码",
                      maxlength: "20"
                    },
                    model: {
                      value: _vm.RegisterForm.password,
                      callback: function($$v) {
                        _vm.$set(_vm.RegisterForm, "password", $$v)
                      },
                      expression: "RegisterForm.password"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "flex flexbox" }, [
            _c(
              "div",
              [
                _c("el-checkbox", {
                  staticStyle: { top: "5px" },
                  model: {
                    value: _vm.checked,
                    callback: function($$v) {
                      _vm.checked = $$v
                    },
                    expression: "checked"
                  }
                })
              ],
              1
            ),
            _c("div", [
              _c("span", { staticClass: "registerRule" }, [
                _vm._v("注册即视为已阅读并同意 "),
                _c(
                  "b",
                  {
                    on: {
                      click: function($event) {
                        return _vm.showrule("REGISTER")
                      }
                    }
                  },
                  [_vm._v("《中鑫金用户注册协议》")]
                ),
                _c(
                  "b",
                  {
                    on: {
                      click: function($event) {
                        return _vm.showrule("PRIVACY_POLICY")
                      }
                    }
                  },
                  [_vm._v("《中鑫金用户隐私政策》")]
                ),
                _c(
                  "b",
                  {
                    on: {
                      click: function($event) {
                        return _vm.showrule("LOCK_PRICE")
                      }
                    }
                  },
                  [_vm._v("《中鑫金定价协议》")]
                ),
                _c(
                  "b",
                  {
                    on: {
                      click: function($event) {
                        return _vm.showrule("STORAGE")
                      }
                    }
                  },
                  [_vm._v("《中鑫金存料协议》")]
                ),
                _c(
                  "b",
                  {
                    on: {
                      click: function($event) {
                        return _vm.showrule("TRANSPORT_POLICY")
                      }
                    }
                  },
                  [_vm._v("《中鑫金运输与保险协议》")]
                )
              ])
            ])
          ]),
          _c(
            "el-button",
            {
              staticClass: "btn_yellow",
              on: {
                click: function($event) {
                  return _vm.handleRegister("RegisterForm")
                }
              }
            },
            [_vm._v("注册")]
          ),
          _c("div", { staticClass: "tc actionbox" }, [
            _c("div", [
              _vm._v("已有账号？去"),
              _c("b", { staticClass: "gologin", on: { click: _vm.loginbtn } }, [
                _vm._v("登录")
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "van-dialog",
        {
          attrs: {
            type: "alert",
            title: "",
            width: "80%",
            "show-cancel-button": ""
          },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c("div", { staticClass: "opopbox" }, [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.msg) } })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }